module.exports = __webpack_public_path__ + "static/media/t1.0afd2675.png";